const FIELD_LABELS = {
  firstName: 'Legal first name',
  lastName: 'Legal last name',
  email: 'Email',
  password: 'Password',
  confirmPassword: 'Confirm password',
  phoneNumber: 'Phone number',
  dateOfBirth: 'Date of birth',
  address: 'Street address',
  city: 'City',
  state: 'State',
  zipCode: 'Zip code',
  country: 'Country',
  customerType: 'Account type',
  businessName: 'Business name',
  businessContact: 'Business contact person',
  ein: 'EIN / Tax ID',
  legalIdentityConfirmed: 'Legal identity confirmation',
};

const getFieldLabel = (field) => {
  if (!field) return '';
  return FIELD_LABELS[field] || field;
};

const cleanMessage = (field, message) => {
  if (!message) return '';

  const label = getFieldLabel(field);

  if (!field || !label) {
    return message;
  }

  return String(message).replaceAll(field, label.toLowerCase());
};

const normalizeDetail = (detail) => {
  if (!detail) return '';

  if (typeof detail === 'string') {
    return detail;
  }

  const field = detail.field || detail.path || detail.param || '';
  const rawMessage = detail.message || detail.msg || detail.error || '';

  const label = getFieldLabel(field);
  const message = cleanMessage(field, rawMessage);

  if (label && message) {
    return `${label}: ${message}`;
  }

  if (message) {
    return message;
  }

  try {
    return JSON.stringify(detail);
  } catch {
    return String(detail);
  }
};

export function getApiErrorMessage(
  data,
  fallback = 'Something went wrong. Please try again.'
) {
  if (!data) return fallback;

  if (typeof data === 'string') {
    return data;
  }

  if (typeof data.message === 'string' && data.message.trim()) {
    return data.message.trim();
  }

  if (Array.isArray(data?.error?.details) && data.error.details.length > 0) {
    return data.error.details
      .map(normalizeDetail)
      .filter(Boolean)
      .join('\n');
  }

  if (Array.isArray(data?.errors) && data.errors.length > 0) {
    return data.errors
      .map(normalizeDetail)
      .filter(Boolean)
      .join('\n');
  }

  if (Array.isArray(data?.details) && data.details.length > 0) {
    return data.details
      .map(normalizeDetail)
      .filter(Boolean)
      .join('\n');
  }

  if (typeof data?.error?.message === 'string' && data.error.message.trim()) {
    return data.error.message.trim();
  }

  if (typeof data?.error === 'string' && data.error.trim()) {
    return data.error.trim();
  }

  return fallback;
}